import { colors } from '../../colors';
var card = {
  textColorDark: colors.black,
  textColorLight: colors.white,
  bgColor: colors.white,
  bgColorHero: colors.white
};
export default card;